import React, { FunctionComponent, useEffect, useState } from 'react';
import Table from '@material-ui/core/Table';
import TableRow from '@material-ui/core/TableRow';
import withContext from '../../ContextAPI/Context_HOC';
import FundNoteProxy from './FundNoteProxy';
import CircularProgress from '@material-ui/core/CircularProgress';

const FundNotesTable: FunctionComponent<{
  context: { fundNoteProxy: FundNoteProxy };
}> = ({ context: { fundNoteProxy } }) => {
  const [notes, setNotes] = useState<any[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const fundNoteSubscription = fundNoteProxy.getFundNoteList().subscribe({
      next: (x) => {
        const tenNewestNotes = x.slice(0, 10);
        if (tenNewestNotes.length === 0) {
          setError('No notes found.');
          setNotes([]);
          setLoading(false);
          return;
        }
        setNotes(tenNewestNotes);
        setError(null);
        setLoading(false);
      },
      error: () => {
        setError('Failed to load notes. Please try again later.');
        setNotes([]);
        setLoading(false);
      },
    });
    return () => {
      fundNoteSubscription.unsubscribe();
    };
  }, [fundNoteProxy]);

  if (error) {
    return (
      <div className="fund-video-loading-container">
        <div className="error-message">{error}</div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="fund-video-loading-container">
        <CircularProgress data-cy="loading-animation-container" className="loading-animation" size={80} />
      </div>
    );
  }

  return (
    <div className="containerStyle">
      <div className="boxStyle">
        <h3>Treasurers Notes</h3>
        <p data-cy="feast-name-container">Feast of {notes[0].feastName.value[0].name}</p>
        <p>
          Treasurers Notes are sent out every nineteen days to be read at Feast. Treasurer Notes includes updates on the Bahá’í
          Funds and other Fund related activities.
        </p>
        <div className="containerStyle">
          <a
            className="home-button small-bottom-margin center"
            href={notes[0].englishPdf.value[0].url}
            target="_blank"
            rel="noopener noreferrer"
          >
            Treasurers Notes (English)
          </a>
          <a
            className="home-button small-bottom-margin center"
            href={notes[0].persianPdf.value[0].url}
            target="_blank"
            rel="noopener noreferrer"
          >
            Treasurers Notes (Persian)
          </a>
        </div>
        <Table>
          <thead>
            <TableRow>
              <th className="cellStyle">
                <strong>Past Notes</strong>
              </th>
              <th className="cellStyle" />
              <th className="cellStyle" />
            </TableRow>
          </thead>
          <tbody>
            {notes.slice(1).map((note) => (
              <TableRow key={note.id}>
                <td className="cellStyle">Feast of {note.feastName.value[0].name}</td>
                <td className="cellStyle">
                  (
                  <a href={note.englishPdf.value[0].url} target="_blank" rel="noopener noreferrer">
                    <u>English</u>
                  </a>
                  )
                </td>
                <td className="cellStyle">
                  (
                  <a href={note.persianPdf.value[0].url} target="_blank" rel="noopener noreferrer">
                    <u>Persian</u>
                  </a>
                  )
                </td>
              </TableRow>
            ))}
          </tbody>
        </Table>
      </div>
      <div className="boxStyle">
        <img src={notes[0].png.value[0].url} alt="Bahai Fund Breakdown for Current Feast" className="home-image" />
      </div>
    </div>
  );
};

export default withContext(FundNotesTable);
